export const backgColorProperty = {
  1: {
    background: {
      audio: "url(" + require('@/static/course/m7.png') + ")",
      ppt: "url(" + require('@/static/course/bg-ppt-0.png') + ")",
      video: "url(" + require('@/static/course/v2.png') + ")",
      image: "url(" + require("@/static/course/i1.png") + ")",
      document: "url(" + require('@/static/course/bgd1.png') + ")"
    },
    textcolor: '#FFF'
  },
  2: {
    background: {
      audio: "url(" + require('@/static/course/m1.png') + ")",
      video: "url(" + require('@/static/course/v3.png') + ")",
      
      ppt: "url(" + require('@/static/course/bg-ppt-1.png') + ")",
      image: "url(" + require("@/static/course/i2.png") + ")",
      document: "url(" + require('@/static/course/bgd2.png') + ")"

    },
    textcolor: '#FFF'
  },
  3: {
    background: {
      audio: "url(" + require('@/static/course/m2.png') + ")",
      video: "url(" + require('@/static/course/v1.png') + ")",
      // 
      ppt: "url(" + require('@/static/course/bg-ppt-2.png') + ")",
      image: "url(" + require("@/static/course/i3.png") + ")",
      document: "url(" + require('@/static/course/bgd3.png') + ")"
    },
    textcolor: '#FFF'
  },
  4: {
    background: {
      audio: "url(" + require('@/static/course/m3.png') + ")",
      video: "url(" + require('@/static/course/v7.png') + ")",
      ppt: "url(" + require('@/static/course/bg-ppt-3.png') + ")",
      image: "url(" + require("@/static/course/i4.png") + ")",
      document: "url(" + require('@/static/course/bgd4.png') + ")"
    },
    textcolor: '#FFF'
  },
  5: {
    // 化学   暂时没有
    background: {
      audio: "url(" + require('@/static/course/m4.png') + ")",
      // ppt: "url(" + require('@/static/course/bg-ppt-1.png') + ")",
      video: "url(" + require('@/static/course/v6.png') + ")",
      // 
      ppt: "url(" + require('@/static/course/bg-ppt-0.png') + ")",
      image: "url(" + require("@/static/course/i5.png") + ")",
      document: "url(" + require('@/static/course/bgd5.png') + ")"
    },
    textcolor: '#FFF'
  },
  6: {
    background: {
      audio: "url(" + require('@/static/course/m5.png') + ")",
      video: "url(" + require('@/static/course/v4.png') + ")",
      ppt: "url(" + require('@/static/course/bg-ppt-2.png') + ")",
      image: "url(" + require("@/static/course/i6.png") + ")",
      document: "url(" + require('@/static/course/bgd6.png') + ")"

    },
    textcolor: '#FFF'
  },
  7: {
    background: {
      audio: "url(" + require('@/static/course/m6.png') + ")",
      video: "url(" + require('@/static/course/v5.png') + ")",
      ppt: "url(" + require('@/static/course/bg-ppt-3.png') + ")",
      image: "url(" + require("@/static/course/i7.png") + ")",
      document: "url(" + require('@/static/course/bgd7.png') + ")"
    },
    textcolor: '#FFF'
  },
  8: {
    background: {
      audio: "url(" + require('@/static/course/m7.png') + ")",
      //ppt: "url(" + require('@/static/course/bg-ppt-1.png') + ")",
      video: "url(" + require('@/static/course/v6.png') + ")",
      // 
      ppt: "url(" + require('@/static/course/bg-ppt-0.png') + ")",
      image: "url(" + require("@/static/course/bg-image-0.png") + ")",
      document: "url(" + require('@/static/course/bgd1.png') + ")"
    },
    textcolor: '#FFF'
  },
  10: {
    background: {
      // audio: "url(" + require('@/static/course/bg-audio-1.png') + ")",
      // ppt: "url(" + require('@/static/course/bg-ppt-1.png') + ")",
      // video: "url(" + require('@/static/course/bg-video-1.png') + ")"
    },
    textcolor: '#FFF'
  },
}